import { Button, Grid, Link, Paper, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useAPI } from '../../../shared/services/api/API';
import { WASHUB_CONSTANTS } from '../../../shared/Constants';
import { TrollyPackageOrderDetails } from '../model/makeData';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { TrollyOrdersList } from './TrollyOrdersList';
declare const qz: any;
export const TrollyManagement = () => {
  const { httpPost, handleAlertBar } = useAPI();
  const [barcode, setBarCode] = useState('');
  const [qrCodes, setQrCodes] = useState(['']);
  const [tables, setTables] = useState<any>([]);
  const [trollyData, setTrollyData] = useState<any>({});
  const qrRef = React.useRef<(HTMLInputElement| null)[]>([]);
  const barcodeRef = React.useRef<HTMLInputElement | null>(null);
  const [isLoading, setIsLoading ] = useState(false);
  const [disabledIndexes, setDisabledIndexes] = useState<number[]>([]);

  const printLabel = async (printerName: string, printerLabel: any) => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }
      let printer = "";
      //If printerName is null, it will use default printer
      if (!printerName) {
        printer = await qz.printers.getDefault();
      } else {
        printer = await qz.printers.find(printerName);
      }
      const config = qz.configs.create(printer);
      for (const label of printerLabel) {
        let data = [];
        if (printerName === "Epson") {
          data = [
            {
              type: "raw",
              format: "command",
              flavor: "base64",
              data: label,
            },
          ];
        } else {
          data = [label];
        }
        await qz.print(config, data);
      }
      handleAlertBar("success", "Labels print successfully");
      setBarCode("");
      setQrCodes([""]);
      setDisabledIndexes([]);
      setTables([]);
      setTrollyData({});
      if (barcodeRef.current) {
        barcodeRef.current.focus();
      }
    } catch (error) {
      alert("Error: " + error);
    }
  };

  const columns = useMemo<MRT_ColumnDef<TrollyPackageOrderDetails>[]>(
    () => [
      {
        accessorKey: 'serviceItem.name',
        header: 'Item',
        size: 10,
      },
      {
        accessorKey: 'balanceItemCount',
        header: 'Balance Count',
        size: 10,
      },
      {
        accessorKey: 'packageCount',
        header: 'Package Count',
        size: 10,
      },
      {
        accessorKey: 'cleanCount',
        header: 'Clean',
        size: 50,
      },
      {
        accessorKey: 'stainCount',
        header: 'Stain',
        size: 10,
      },
      {
        accessorKey: 'damageCount',
        header: 'Damage',
        size: 10,
      },
    ],
    [],
  );

  const fetchTrollyPackage = (index: number, qrCode: string) => {
    const reqBody: any = {
      trollyId: barcode,
      packageQRCode: qrCode,
    };
    if (trollyData?.trollyPackageOrderId) {
      reqBody['trollyPackageOrderId'] = trollyData?.trollyPackageOrderId
    }
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_PACKAGE_ORDER_CREATE_POST}`,
      reqBody,
    ).then((response) => {
      if (response.status === 200) {
        const updatedQrCodes = [...qrCodes];
        updatedQrCodes[index] = qrCode;
        if (index === qrCodes.length - 1 && qrCode) {
          updatedQrCodes.push('');
          setTimeout(() => {
            qrRef.current[index + 1]?.focus();
          }, 1000);
          setQrCodes(updatedQrCodes);
        }
        setTrollyData(response.data);
        console.log('response.data', response.data);
        setTables(response?.data?.trollyPackageOrder);
      } else {
        if (response.data.error) {
          if (response.data.message === 'INVALID_OPERATION') {
            handleAlertBar('error', 'Invalid operation');
          } else if (response.data.message === 'PACKAGE_ALREADY_SCANNED') {
            handleAlertBar('error', 'Package already scanned');
          } else if (response.data.message === 'TROLLEY_IS_BUSY') {
            handleAlertBar('error', `${barcode} Trolly is busy`);
          }
          const updatedQrCodes = [...qrCodes];
          setDisabledIndexes((prev) =>
            prev
              .filter((i) => i !== index)          
              .map((i) => (i > index ? i - 1 : i))   
          );
          updatedQrCodes[index] = '';
          setQrCodes(updatedQrCodes);
          qrRef.current[index]?.focus();
          
        }
      }
    });
  };

  const removeQrCode = (index: number, qrCode: string) => {
    const reqBody: any = {
      trollyId: barcode,
      packageQRCode: qrCode,
    };
    if (trollyData?.trollyPackageOrderId) {
      reqBody['trollyPackageOrderId'] = trollyData?.trollyPackageOrderId
    }
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_PACKAGE_DELETE_POST}`,
      reqBody,
    ).then((response) => {
      if (response.status === 200) {
        setDisabledIndexes((prev) =>
          prev
            .filter((i) => i !== index)          
            .map((i) => (i > index ? i - 1 : i))   
        );
        setQrCodes(qrCodes.filter((_, i) => i !== index));
        setTrollyData(response.data);
        setTables(response?.data?.trollyPackageOrder);
      } else {
        if (response.data.error) {
          console.error(
            'Error fetching BusinessStore: ',
            response.data.message,
          );
        }
      }
    });
  };

  const handleQrScan = (index: number, value: string) => {
    const updatedQrCodes = [...qrCodes];
    updatedQrCodes[index] = value;
    setQrCodes(updatedQrCodes);
    if(value.toLocaleUpperCase().endsWith('ZZ')) {
      setDisabledIndexes((prev) => [...prev, index]);
      fetchTrollyPackage(index,value);
    }
  };

  const handleBarCode = (value: string) => {
    setBarCode(value);

    if(value) {
      setTimeout(()=>{
        qrRef.current[0]?.focus();
      }, 1000);
    }
  };

  const fetchPrintBatch = () => {
    setIsLoading(true);
    const reqBody = {
      trollyId: barcode,
      packageOrderId: trollyData?.trollyPackageOrderId,
      orderId: trollyData?.trollyPackageOrder?.map((item: any) => {
        return item.orderId;
      })[0],
    };
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_PRINT_DISPATCH_POST}`,
      reqBody,
    ).then((response) => {
      if (response.status === 200) {
        try {
          if (response?.data?.label?.length > 0) {
            printLabel('', response?.data?.label);
          }
          if (response?.data?.epsonLabel?.length > 0) {
            printLabel('Epson', response?.data?.epsonLabel);
          }
        } catch (error: any) {
          throw new Error('Error fetching Print label: ', error);
        }
        setIsLoading(false);
      } else {
        if (response.data.error) {
          console.error('Error fetching Print label: ', response.data.message);
          setIsLoading(false);
        }
      }
    });
  };

  useEffect(() =>{
    if (barcodeRef.current) {
      barcodeRef.current.focus();
    }
  }, []);

  return (
    <div style={{ width: '100%', maxHeight: '85vh', overflow: 'auto' }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            color={'primary'}
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Trolly Management
          </Typography>
        </Grid>
      </Grid>
      {tables.length > 0 &&  (
        <div
          style={{ padding: '5px 15px', maxHeight: '45vh', overflow: 'auto' }}
        >
          {tables?.map((order: any, idx: number) => (
            <Paper key={idx} className="pt-2 px-2 mb-2">
              <div className='d-flex justify-content-between'>
                <Typography>{`Order Id: ${order.orderId}`}</Typography>
                <Typography>{`Package Order ID: ${trollyData?.trollyPackageOrderId}`}</Typography>
              </div>
              <MaterialReactTable
                defaultColumn={{
                  maxSize: 150,
                  minSize: 10,
                  size: 50,
                }}
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                    width: '100%',
                    '& .css-1tbggly': {
                      minHeight: '0px',
                    },
                    '& .css-10gei56': {
                      minHeight: '0px',
                    },'&. css-1llu0od':{
                      minHeight: '0px',
                    }
                  },
                }}
                columns={columns}
                enableFullScreenToggle={false}
                enableStickyHeader
                positionActionsColumn="last"
                enableRowActions={false}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableFilters={false}
                enablePagination={false}
                enableSorting={false}
                enableHiding={false}
                enableDensityToggle={false}
                enableToolbarInternalActions={false}
                data={order.trollyPackageOrderItem}
                editDisplayMode="modal"
                muiTableContainerProps={{
                  sx: {
                    height: 'auto',
                  },
                }}
              />
            </Paper>
          ))}
        </div>
      )}

      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <Grid
        container
        display={'flex'}
        flexDirection={'row'}
        className="p-4"
        // sx={{ maxHeight: '10vh', overflow: 'auto' }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <input
            type="text"
            id='trollyBarCode'
            value={barcode}
            placeholder="Scan the Trolly..."
            onInput={(e) => handleBarCode((e.target as HTMLInputElement).value)}
            ref={barcodeRef}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <div>{`Total Package scan: ${qrCodes.filter((qr: string) => qr !== '').length}`}</div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          {qrCodes?.map((qr: string, index: number) => (
            <Grid
              container
              key={index}
              display={'flex'}
              flexDirection={'row'}
              className="mb-4"
            >
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <input
                  type="text"
                  style={{ width: '100%' }}
                  data-index={index}
                  value={qr}
                  placeholder="Scan the Package label..."
                  onInput={(e) => handleQrScan(index, (e.target as HTMLInputElement).value)}
                  ref={(el) => qrRef.current[index] = el}
                  disabled={disabledIndexes.includes(index)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                {qr && (
                  <Link component="button" title={'Remove'}>
                    <CloseIcon
                      className="ms-4 mb-1"
                      color="error"
                      fontSize="small"
                      onClick={() => removeQrCode(index, qr)}
                    />
                  </Link>
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <div className="d-flex justify-content-end me-2">
        <Button
          variant="contained"
          className="me-2 mb-2"
          onClick={() => {
            fetchPrintBatch();
          }}
          disabled={isLoading || !barcode || qrCodes.filter((qr: string) => qr !== '').length === 0}
        >
          Print Batch Label
        </Button>
      </div>
      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <TrollyOrdersList />
    </div>
  );
};
